module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_03-4b2f9e688b8a36ebabcd456377b52610.png";